import Layout from "@/components/Layout";
import ProfileSettings from "@/components/ProfileSettings";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function AccountSettings() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (!loading && !user) nav("/login?next=/account/settings", { replace: true });
  }, [loading, user, nav]);

  if (loading || !user) {
    return (
      <Layout>
        <div className="min-h-screen pt-32 pb-24 bg-[#0B0B0C] text-center text-xs uppercase tracking-[0.3em] text-[#8E9AA6]">
          Authorising…
        </div>
      </Layout>
    );
  }
  return (
    <Layout>
      <section className="pt-32 pb-24 bg-[#0B0B0C] min-h-screen">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-[11px] uppercase tracking-[0.4em] text-[#8E9AA6] mb-3">Settings</div>
          <h1 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-white mb-12">
            Profile &amp; Security
          </h1>
          <ProfileSettings />
        </div>
      </section>
    </Layout>
  );
}
